import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { navigate } from 'redux-saga-first-router';

import Layout from '../Layout';

const LoginSuccess = withTranslation()(({ firstName = '', lastName = '', email, navigateLogin, t }) => {
  const fullName = `${firstName} ${lastName}`.trim();
  if (!email) {
    navigateLogin();
    return null;
  }

  return (
    <div className="wrapper success login-success">
      <Layout type="login-success" cover={{ src: '/images/cover-main.png' }}>
        <div className="wrapper-shrink">
          <img src="/images/Success.svg" alt="success" />
          <div className="title">
            <strong>{t('Authentication complete.')}</strong>
          </div>
          <div className="signed-in-as">
            <span>{t('Signed in as')}</span>
            <br /> <strong className="username">{fullName}</strong> <br />
            <span>{email}</span>
          </div>
          <div className="info">
            {t('You may now close this window')} <br />
          </div>
        </div>
      </Layout>
    </div>
  );
});

export default connect(
  (state) => ({ email: state.app.email, firstName: state.app.firstName, lastName: state.app.lastName }),
  (dispatch) => ({
    navigateLogin: () => dispatch(navigate('LOGIN')),
  }),
)(LoginSuccess);
